// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".two-columns .primary[data-v-0d6ef64a] {\n  padding-right: 30px;\n  border-right: 1px solid #eee;\n}\n.two-columns .secondary[data-v-0d6ef64a] {\n  padding-left: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
